//import './assets/odoo.css';
import "./assets/agm_kendo_bck_v1_2.css";
import "./App.css";
import React from "react";
import PoliciesComparative, {
  PolicyDetails,
} from "./Components/Views/Comparative";
import RingLoader from "react-spinners/RingLoader";
import { getOportunity } from "./Utils/getOportunity";
import PolicyList from "./Components/Views/Policies";
import { Route, Switch } from "react-router-dom";
import OrganizeQuotes from "./Utils/organizeQuotes";
import PrivateRoute from "./Components/Others/PrivateRoute";
import Row from "react-bootstrap/Row";
import EmbebedComplements from "./Components/Others/EmbebedComplements";
import ImportIcons from "./Components/Others/ImportIcons";
import modifyCoverages from "./Utils/modifyCoverages";
import updateGroups from "./Utils/updateGroups";
import { response } from "./Utils/staticResponse";

const socket = new WebSocket("wss://www.agm-dev.com/websocket/");

export const DataContext = React.createContext({});

const url = new URLSearchParams(window.location.search);
const tenant =
  url.get("tenant") || window.odoo?.session_info?.db || window.location.host;
const messageError = url.get("message_error") || false;
const origin = `https://${tenant}`;
const uid = require("uuid");

function App({ root }) {
  const [context, setContext] = React.useState({
    isDebug:
      process.env.NODE_ENV === "development" ||
      window.origin.includes("localhost:8069")
        ? true
        : false,
  });
  const [connectionsTries, setConnectionsTries] = React.useState(0);
  const [idOportunity, setIdOportunity] = React.useState(null);
  const [socketConnected, setSocketConnected] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const sessionId = React.useMemo(() => uid.v4(), []);

  React.useEffect(() => {
    const name = url.get("id_oportunity") || url.get("id_opportunity") || "730";
    const token =
      url.get("access_token") || "42ede136-ee2e-410b-adec-1aa6098ab8b8";
    const urlSearch = window.location.search;
    const noCache = url.get("noCache") || false;
    getOportunity(origin, name, token, noCache)
      .then((res) => {
        console.log(res);
        //!organize quotes
        var policy_list = res.policy_list;
        policy_list = OrganizeQuotes(policy_list);
        res.policy_list = policy_list;

        setContext({
          ...context,
          oportunity: res,
          id_op: name,
          policies: res.policy_list,
          urlSearch: urlSearch,
          groups: res.groups,
          origin: origin,
          setLoading: setLoading,
        });
        setLoading(false);
        setIdOportunity(name);
      })
      .catch(() => {
        //! Solo para pruebas se pone una respuesta estática
        if (context.isDebug) {
          let res = response;
          //!organize quotes
          var policy_list = res.policy_list;
          policy_list = OrganizeQuotes(policy_list);
          res.policy_list = policy_list;
          setContext({
            ...context,
            oportunity: res,
            id_op: name,
            policies: res.policy_list,
            urlSearch: urlSearch,
            groups: res.groups,
            origin: origin,
            setLoading: setLoading,
          });
          setLoading(false);
          setIdOportunity(name);
        }
      });
  }, []);

  socket.onopen = () => {
    console.log("Socket Conectado");
    setSocketConnected(true);
  };

  //socket part
  socket.onmessage = (evt) => {
    try {
      const eventData = JSON.parse(evt.data);
      const { name, data, groups } = eventData;
      if (name == "update-policy") {
        if (
          context.policies.find((policy) => policy.id_db == data.id_db) ===
          undefined
        ) {
          setContext({ ...context, policies: [...context.policies, data] });
          updateGroups(groups, context.groups, setContext);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const tryConnection = () => {
    try {
      socket.send(
        JSON.stringify({
          meta: "create_room",
          roomID: tenant + "_crm.lead_" + idOportunity,
          clientID: sessionId,
          message: "",
        })
      );
    } catch (e) {
      console.log(e);
      setConnectionsTries((prev) => prev + 1);
    }
  };

  React.useEffect(() => {
    if (connectionsTries > 5 || connectionsTries === 0) return;
    tryConnection();
  }, [connectionsTries]);

  React.useEffect(() => {
    if (!idOportunity || !socketConnected) return;
    console.log("Intentando Crear Sala");
    tryConnection();
  }, [idOportunity, socketConnected]);

  if(messageError){
    const words = messageError.split(' ');
    const firstWord = words.shift();

    return <>
    <div className="App">
      <h2 style={{textAlign:"center",fontSize:"4rem"}}>
        {firstWord}
      </h2>
      <span className="d-flex justify-content-center text-center w-75 m-auto" style={{fontSize:"1.2rem"}}>
        {words.join(' ')}
      </span>
      
    </div>
    </>;
  } 


  return (
    <React.Fragment>
      <div className="App">
        {root === "AGMroot" && <EmbebedComplements />}
        <ImportIcons />
        <DataContext.Provider
          value={{ context: context, setContext: setContext }}
        >
          {loading ? (
            <Row className="justify-content-center mt-3">
              <RingLoader color="var(--company-color)"></RingLoader>
            </Row>
          ) : (
            <Switch>
              <PrivateRoute exact path="*/comparative" origin="comparative">
                <PoliciesComparative />
              </PrivateRoute>
              <PrivateRoute exact path="*/details" origin="detail">
                <PolicyDetails />
              </PrivateRoute>
              <Route exact path="*/" component={PolicyList} />
            </Switch>
          )}
          {/* <PoliciesComparative /> */}
        </DataContext.Provider>
      </div>
    </React.Fragment>
  );
}

export default App;
